import React from 'react';
import Grid from '@material-ui/core/Grid/Grid';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Theme } from '@material-ui/core/styles';
import CantFindOrganizationCard from './CantFindOrganizationCard';

interface RenderSearchResultGridProps<T> {
    list: T[];
    RenderComponent: React.FC<{ data: T }>;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        gridStyles: {
            marginBottom: theme.spacing(3),
            '& .search-grid': {
                padding: theme.spacing(2),
            },
        },
    }),
);

const RenderSearchResultGrid = <T,>({
    list,
    RenderComponent,
}: RenderSearchResultGridProps<T>) => {
    const { gridStyles } = useStyles();
    return (
        <Grid container className={gridStyles}>
            {list.map((c, i) => (
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={4}
                    xl={4}
                    key={i}
                    className="search-grid"
                >
                    <RenderComponent data={c} />
                </Grid>
            ))}
            <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={4}
                xl={4}
                className="search-grid"
            >
                <CantFindOrganizationCard />
            </Grid>
        </Grid>
    );
};

export default RenderSearchResultGrid;
